<template>
  <div>
    <DataUpgrade></DataUpgrade>
  </div>
</template>

<script>

import DataUpgrade from '../components/DataUpgrade.vue';
export default {
  components: {
    DataUpgrade,
  },
};
</script>